import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Spin } from 'antd';
import { HttpService } from '@core/services';
import { SiteHttpService } from '@core/services/http';
import { AssociatedProjects } from '@shared/components';
import { SiteActions } from '@store/actions';
import { SiteSelectors } from '@store/selectors';

type SiteAssociatedProjectsProps = RouteComponentProps & {
  isActive?: boolean;
};

export const SiteAssociatedProjects: FC<SiteAssociatedProjectsProps> = ({
  isActive,
  ...props
}: SiteAssociatedProjectsProps) => {
  const dispatch = useDispatch();
  const { currentSite, associatedProjects } = useSelector(
    SiteSelectors.getSiteAssociatedProjectsInfo,
  );
  const isLoading = useSelector(
    SiteSelectors.getTabLoadingState('associatedProjects'),
  );
  const isDataLoaded = useSelector(
    SiteSelectors.getTabLoadedState('associatedProjects'),
  );
  const locationCode =
    currentSite?.PSLocationCode ?? currentSite?.MDGLocationCode;

  useEffect(() => {
    if (isActive && locationCode && !isDataLoaded && !isLoading) {
      dispatch(
        SiteActions.setTabLoading.done({
          tabName: 'associatedProjects',
          isLoading: true,
        }),
      );
      HttpService.getHttpRequests(SiteHttpService)
        .getSiteAssociatedProjects(locationCode)
        .catch(() =>
          dispatch(
            SiteActions.setTabError.done({
              tabName: 'associatedProjects',
              hasError: true,
            }),
          ),
        );
    }
  }, [dispatch, isActive, isDataLoaded, isLoading, locationCode]);

  if (isLoading || !isDataLoaded) {
    return (
      <div className="prov-site-associated-projects loading">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <AssociatedProjects
      {...props}
      linkId={currentSite?.PSLocationCode?.toString() ?? ''}
      data={associatedProjects}
      isSiteOn={currentSite.isSiteOn || false}
    />
  );
};
